import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import {
  EmployeeActions,
  EMPLOYEE_STATE_NAMESPACE
} from './employee.module-types';

export const dispatchEmployeeAction: DispatchAction<EmployeeActions> = getDispatch(
  EMPLOYEE_STATE_NAMESPACE
);
